import { TriangleDownIcon, TriangleUpIcon } from "@radix-ui/react-icons"
import classNames from "classnames"

import styles from "./CancelSortControl.module.scss"

import {
	CANCEL_SORT_KEY_LABEL,
	CANCEL_SORT_ORDER_LABEL,
	CancelSortKey,
	CancelSortState,
} from "../useCancelSort"

type Props = {
	sortKeys: CancelSortKey[]
	sort: CancelSortState
	onClickSortKey: (key: CancelSortKey) => void
}

/**
 * キャンセル一覧の並び替えボタン。
 *
 * 同じボタンを押すたびに 新しい順 → 古い順 → 解除 と切り替わる。
 */
export const CancelSortControl = ({
	sortKeys,
	sort,
	onClickSortKey,
}: Props) => {
	if (sortKeys.length === 0) {
		return null
	}

	return (
		<div className={styles.sort_control}>
			<span className={styles.label}>並び替え</span>
			{sortKeys.map((key) => {
				const isSelected = sort !== null && sort.key === key
				return (
					<button
						key={key}
						type="button"
						className={classNames(styles.sort_button, {
							[styles.selected]: isSelected,
						})}
						aria-pressed={isSelected}
						onClick={() => onClickSortKey(key)}
					>
						<span>{CANCEL_SORT_KEY_LABEL[key]}</span>
						{isSelected && (
							<>
								{sort.order === "ASC" ? (
									<TriangleUpIcon className={styles.icon} />
								) : (
									<TriangleDownIcon className={styles.icon} />
								)}
								<span className={styles.order_label}>
									{CANCEL_SORT_ORDER_LABEL[sort.order]}
								</span>
							</>
						)}
					</button>
				)
			})}
		</div>
	)
}

export default CancelSortControl
